
























































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Filter } from '@/interfaces/filter.interface'
import { APIPagination } from '@/models/api/pagination.model'
import ADMRouteMetaData from '@/models/dynamic-routes/adm-route-metadata.model'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class ADM extends Vue {
    confirmDialogTrigger = false
    confirmDialogRestoreTrigger = false
    confirmDialogData = null

    selectedRows = []
    sortBy = ''
    sortDesc = false

    loading = false

    data: object[] = []

    customColums: ADMColumn[] = []

    passwordDialog = false
    passwordDialogValid = false
    triggerConfirm = false

    uploadFromFile = {
        active: false,
        mode: 'Add',
        valid: false,
        file: null
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {
        userId: null,
        password: '',
        passwordRepeated: ''
    }

    formRules = {
        password: [
            (v: string) => !!v || 'Password is required',
            (v: string) => (v && v.length > 7) || 'Password must have more than 7 characters'
        ]
    }

    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    rowsPerPage = 15

    filterList: Filter[] = []
    filters: Filter[] = []

    get passwordRepeated () {
        return (this.formData.password === this.formData.passwordRepeated) || 'Passwords dont match'
    }

    get storePagination () {
        const connectionName = this.$route.meta.connectionName
        return this.$store.state[`${connectionName}Store`][`${connectionName.toLowerCase()}Paginate`] || {}
    }

    @Watch('pagination', { deep: true })
    paginationHandler () {
        if (this.pagination.currentPage === this.storePagination.currentPage) return
        this.loadData()
    }

    @Watch('filters')
    onFiltersChange () {
        if (this.filters.length === 0) this.filterHandler()
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSortBy (item: any) {
        this.sortBy = item || ''
        if (this.sortBy === '') return
        this.loadData()
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateSort (item: any) {
        if (this.sortDesc === !!item) return
        this.sortDesc = !!item
        this.loadData()
    }

    newLimitHandler (val: number) {
        this.rowsPerPage = val
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    filterHandler () {
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    resetPassword (newFormData: {[key: string]: string}) {
        this.$store.dispatch('resetPassword', { userId: newFormData.userId, password: newFormData.password, confirmPassword: newFormData.passwordRepeated })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                }
            })
    }

    uploadFile () {
        let dispatchName = 'createBlacklistsFromFile'
        if (this.uploadFromFile.mode === 'Remove') dispatchName = 'deleteBlacklistsFromFile'
        const message = this.uploadFromFile.mode === 'Remove' ? 'Delete successful' : 'File Uploaded'

        this.$store.dispatch(dispatchName, this.uploadFromFile.file)
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', message)
                    setTimeout(() => {
                        this.loadData()
                    }, 100)
                }
            })
    }

    mounted () {
        const meta: ADMRouteMetaData = this.$route.meta // TODO Get all custom fields
        meta.columns.forEach((column: ADMColumn) => {
            if (column.customField) this.customColums.push(column)
        })
        this.getFilters()

        this.loadData()
    }

    getFilters () {
        if (!this.$route.meta.filters) return
        this.filterList = this.$route.meta.filters.map((filter: Filter) => {
            filter.queryValue = ''
            return filter
        })
    }

    addFilter () {
        this.filters.push(JSON.parse(JSON.stringify(this.filterList[0])))
    }

    updateFilter (index: number, newFilter: string) {
        const foundFilter = this.filterList.find(filter => filter.value === newFilter)
        if (foundFilter) this.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        this.$forceUpdate()
    }

    removeFilter (filterIndex: number) {
        this.filters = this.filters.filter((filter, index) => index !== filterIndex)
        this.$forceUpdate()
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchVariableWithArray (variable: string, inputAttibute: string, outputAttibute: string, array: any[], output?: any[]): void|string|number {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const match: any = array.find(item => item[inputAttibute] === variable)
        if (output) output.push(match)
        if (!output) return match ? match[outputAttibute] : '-'
    }

    $eval (item: {[key: string]: string}, type: string, evalString: string, parameters: string) {
        switch (type) {
        case 'route': {
            const params = { id: item[parameters], action: 'edit' }
            this.$router.push({ name: evalString, params })
            break
        }
        case 'routeMenu': {
            const params = { parent: item[parameters] }
            this.$router.push({ name: evalString, params })
            break
        }
        case 'userPassword': {
            this.formData.userId = item.userId
            this.passwordDialog = true
            break
        }
        default:
            this.$store.commit('reportError', { code: 1000, message: 'A custom field does not have a matching actionType :(' })
            break
        }
    }

    confirmedDialog (callback: {[key: string]: string|number|boolean}) {
        const connectionName = this.$route.meta.connectionName
        this.$store.dispatch(`delete${connectionName}`, callback[this.$route.meta.idField])
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.loadData()
                }
            })
    }

    confirmedRestoreDialog (callback: {[key: string]: string|number|boolean}) {
        const connectionName = this.$route.meta.connectionName
        this.$store.dispatch(`restore${connectionName}`, callback[this.$route.meta.idField])
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.loadData()
                }
            })
    }

    loadData () {
        this.loading = true
        const connectionName = this.$route.meta.connectionName

        if (!connectionName) {
            this.loading = false
            this.data = []
            this.$store.commit('reportError', { code: 1000, message: 'Missing connection name in dinamic route :(' })
            return
        }

        this.$store.dispatch(`get${connectionName}Paginate`, {
            page: this.pagination.currentPage,
            filters: this.filters,
            limit: this.rowsPerPage,
            sortBy: this.sortBy,
            sort: !this.sortDesc ? 'asc' : 'desc'
        })
            .then(resp => {
                if (resp?.status === 200) {
                    this.pagination = { ...this.$store.state[`${connectionName}Store`][`${connectionName.toLowerCase()}Paginate`] }
                    this.data = this.$store.state[`${connectionName}Store`][`${connectionName.toLowerCase()}Paginate`].results || []

                    if (this.pagination.results) delete this.pagination.results

                    if (!this.pagination?.currentPage) this.pagination.currentPage = 1

                    this.loading = false
                }
            })
    }

    getDateFormat (dateString: string) {
        if (!dateString || dateString === '') return ''
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
